import React, { useEffect } from "react";
import { MusicHallBookingEmailFormStyled } from "./styled";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Buttons, Inputs } from "components";
import { MdAdd, MdDelete } from "react-icons/md";

const MusicHallBookingEmailForm = ({ initialValue, permission, onSubmit }) => {
  const schema = yup.object().shape({
    // date: yup.string().required("required"),
    // emails1: yup
    //   .array()
    //   .of(yup.string().email("Invalid email").required("Email is required")),
    // emails2: yup
    //   .array()
    //   .of(yup.string().email("Invalid email").required("Email is required")),
    // emails3: yup
    //   .array()
    //   .of(yup.string().email("Invalid email").required("Email is required")),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const {
    fields: fields1,
    append: append1,
    remove: remove1,
  } = useFieldArray({
    control,
    name: "emails1",
  });

  useEffect(() => {
    if (initialValue) {
      reset({
        ...initialValue,
      });
    }
  }, [initialValue]); // eslint-disable-line react-hooks/exhaustive-deps

  const addEmail1 = () => append1("");

  return (
    <MusicHallBookingEmailFormStyled>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="title">การส่ง Email แจ้งเตือน</div>
        <div className="f_header">
          <div className="f_title">1. ส่งอีเมลแจ้งเตือนเมื่อมีการจองห้องดนตรี</div>

          <div className="f_right_col">
            {fields1.map((item, index) => (
              <div key={item.id} className="email-field">
                <Controller
                  control={control}
                  render={({ field }) => (
                    <Inputs.TextField
                      {...field}
                      errors={errors.emails1?.[index]?.message}
                      placeholder={`Email ${index + 1}`}
                    />
                  )}
                  name={`emails1[${index}].email`}
                  defaultValue={item.email || ""}
                />
                <button
                  className="btn_delete"
                  type="button"
                  onClick={() => remove1(index)}
                >
                  <MdDelete size={30} />
                </button>
              </div>
            ))}
            {permission.is_create && (
              <div className="btn_submit_wrap">
                <Buttons.BgIconPrefix
                  type="button"
                  icon={<MdAdd size={18} />}
                  label="Add Email"
                  onClick={addEmail1}
                />
              </div>
            )}
          </div>
        </div>
        <div className="sec_btn_submit">
          <div className="btn_submit_wrap">
            <Buttons.BgIconPrefix type="submit" label="บันทึก" />
          </div>
        </div>
      </form>
    </MusicHallBookingEmailFormStyled>
  );
};

MusicHallBookingEmailForm.propTypes = {};

export default MusicHallBookingEmailForm;
